module.exports = __webpack_public_path__ + "static/img/ES@3x.66136c4c.jpg";